export function isEmpty(arr: ReadonlyArray<unknown>): boolean {

  return !Array.isArray(arr) || arr.length === 0;
}